import React from "react";
import { useNavigate } from "react-router-dom";
import { DeliveryAreaManager } from "../../components/delivery-areas/DeliveryAreaManager";

// Thin Settings-nav wrapper around the manager dialog, matching
// ExpenseCategoryManagement's pattern — closing returns to the Settings hub
// since this route has nothing else to show once the dialog goes away.
export const DeliveryAreaManagement: React.FC = () => {
    const navigate = useNavigate();

    return (
        <DeliveryAreaManager open={true} onClose={() => navigate("/settings")} />
    );
};
